import React from "react"
import { MdLock } from "react-icons/md"
import { useTranslation } from "react-i18next"

const DisabledColors = ({ title }: { title: string }) => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        height: "120px",
        // backgroundColor: "white",
      }}
      className="px-3 py-2 d-flex flex-column gap-2 rounded-3 "
    >
      <h5 className="text-sm" style={{ color: "#D2D2D2", fontSize: "1rem" }}>
        {/* {t("invitation.availableColors")} */}
        {title}
      </h5>

      <div
        className="rounded-2"
        style={{
          backgroundColor: "#F7F5F5",
          minHeight: "45px",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingLeft: "12px",
          paddingRight: "12px",
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          flexWrap: "nowrap",
          overflowX: "auto",
          maxWidth: "100%",
          whiteSpace: "nowrap",
          scrollbarWidth: "thin",
          scrollbarColor: "#888 #f1f1f1",
        }}
      >
        {/* Disabled colors */}
        {[...Array(8)].map((_, index) => (
          <div
            key={index}
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#dbd9d9", // Muted color for disabled
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "not-allowed", // Indicate that it's disabled
              opacity: 0.6, // Reduce opacity for a disabled effect
              flexShrink: 0,
              border: "3px solid #b7b3b3",
            }}
          >
            <MdLock
              style={{
                width: "12.89px",
                height: "12.89px",
                color: "#9e9e9e", // Muted color for the lock icon
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
export default DisabledColors
